import React, { useState, useEffect } from "react";
import axios from "axios";

const Sidebar = ({ onSelectDepartment , selectedDepartment}) => {
    const [departments, setDepartments] = useState([]);

    useEffect(() => {
        axios.get("https://ndcapp.in/webapi/invdepts/invdeptlist1db.php?action=departments")
            .then(response => setDepartments(response.data))
            .catch(error => console.error("Error fetching departments", error));
    }, []);

    return (
        <div className="bg-dark text-white p-3" style={{ width: "250px", background: "#ddd", padding: "10px" }}>
            <h4 className="text-center">Departments</h4>
            <ul className="list-group">
                {departments.map(dept => (
                    <li key={dept.invdeptid}
                      
                        className={`list-group-item list-group-item-action ${selectedDepartment === dept.invdeptid ? "active" : ""}`}
                        onClick={() => onSelectDepartment(dept.invdeptid)}
                        style={{ cursor: "pointer" }}>
                        {dept.invdeptname}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Sidebar;
